$.fn.Parallax = function(options) {
  let self = this
  self.scrollEvents = $(window).ScrollEvents();

  self.calculatePosition = function() {
    var el_height = self.height();
    var base_height = $(window).height() + el_height;
    var offset = self.offset().top;
    var scrolltop = $(window).scrollTop();
    if (scrolltop + $(window).height() > offset && scrolltop < offset + el_height) {
      var nominateur = (scrolltop - offset - el_height) * -1 ;
      var percent = (base_height - nominateur) * 100 / base_height;
      self.css('--parallax-percentage', percent);
    }
  }

  return function() {
    self.scrollEvents.add(self.calculatePosition);
    return self
  }()
}
